export const quickBottomAnimationProps = {
        initial: { opacity: 0, y: 50 },
        whileInView: { opacity: 1, y: 0, transition:{ delay: 0.2, duration: 0.75 } },
        viewport: { once: true, amount: 0.5},
};

export const middleBottomAnimationProps = {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0, transition:{ delay: 0.4, duration: 0.75 } },
    viewport: { once: true, amount: 0.5},
};

export const quickSmallBottomAnimationProps = {
    initial: { opacity: 0, y: 25 },
    whileInView: { opacity: 1, y: 0, transition:{ delay: 0.2, duration: 0.75 } },
    viewport: { once: true, amount: 0.5},
};

export const middleSmallBottomAnimationProps = {
initial: { opacity: 0, y: 25 },
whileInView: { opacity: 1, y: 0, transition:{ delay: 0.4, duration: 0.75 } },
viewport: { once: true, amount: 0.5},
};

export const quickLeftAnimationProps = {
    initial: { opacity: 0, x: -50 },
    whileInView: { opacity: 1, x: 0, transition:{ delay: 0.2, duration: 0.75 } },
    viewport: { once: true, amount: 0.5},
};

export const middleLeftAnimationProps = {
    initial: { opacity: 0, x: -50 },
    whileInView: { opacity: 1, x: 0, transition:{ delay: 0.4, duration: 0.75 } },
    viewport: { once: true, amount: 0.5},
};

export const quickRightAnimationProps = {
    initial: { opacity: 0, x: 50 },
    whileInView: { opacity: 1, x: 0, transition:{ delay: 0.2, duration: 0.75 } },
    viewport: { once: true, amount: 0.5},
};

export const middleRightAnimationProps = {
    initial: { opacity: 0, x: 50 },
    whileInView: { opacity: 1, x: 0, transition:{ delay: 0.4, duration: 0.75 } },
    viewport: { once: true, amount: 0.5},
};
